import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material-module';
import { SharedModule } from '../shared/shared.module';
import { CoreRoutingModule } from './core-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LayoutModule } from '../layout/layout.module';
import { SurveyModule } from '../survey-main/survey.module';
import { LoaderService } from './services/loader.service';
import { LoaderInterceptor } from './services/loaderInterceptor.service';
import { ActivitiesModule } from '../activities/activities.module';
import { ActivitiesLiteModule } from '../activities-lite/activities-lite.module';
import { V2HeaderComponent } from '../v2-layout/v2-header/v2-header.component';
import { CdTimerModule } from 'angular-cd-timer';
import { V2FooterComponent } from '../v2-layout/v2-footer/v2-footer.component';
import { LoaderComponent } from './loader/loader.component';


export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/');
}
@NgModule({
    declarations: [LoaderComponent,V2HeaderComponent, V2FooterComponent],
    imports: [
        CommonModule,
        CoreRoutingModule,
        SharedModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        LayoutModule,
        ActivitiesModule,
        ActivitiesLiteModule,
        SurveyModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        CdTimerModule
    ],
    providers: [
        LoaderService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    ],
    exports: [LoaderComponent,V2HeaderComponent, V2FooterComponent]
})
export class CoreModule { }
